module.exports = __webpack_public_path__ + "static/019.thumb-0644514283edaf2cd6ac32b2be7f1248.jpg";